import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";
import { MonoTag, CourtLines } from "./motifs";

const TARGET = new Date("2026-12-18T09:00:00");
const LABELS = [
  { fr: "Jours", en: "Days", es: "Días" },
  { fr: "Heures", en: "Hours", es: "Horas" },
  { fr: "Minutes", en: "Minutes", es: "Minutos" },
  { fr: "Secondes", en: "Seconds", es: "Segundos" },
];

const calc = () => {
  const d = Math.max(0, TARGET - new Date());
  return [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
};

export const Countdown = () => {
  const { t } = useLang();
  const [vals, setVals] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setVals(calc()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <section data-testid="countdown-section" className="relative overflow-hidden border-y border-white/10 py-16 md:py-20 grain"
      style={{ backgroundColor: "#0F2027" }}>
      <CourtLines className="-right-56 -top-40 w-[560px] h-[560px]" />
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <MonoTag className="blink" style={{ color: "#A4C8E1" }}>
            ● {t({ fr: "Prochain embarquement", en: "Next boarding", es: "Próximo embarque" })}
          </MonoTag>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.9] mt-4">Winter Cup</h2>
          <p className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.25em] text-white/60 mt-4">
            18 DEC 2026 · INDOOR · U13–U18
          </p>
          <div className="mt-4">
            <MonoTag className="blink inline-block border rounded-full px-3 py-1.5" style={{ color: "#F6B02C", borderColor: "#F6B02C66" }}>
              {t({ fr: "Places limitées · 16 équipes", en: "Limited spots · 16 teams", es: "Plazas limitadas · 16 equipos" })}
            </MonoTag>
          </div>
          <Link to="/evenements" data-testid="countdown-cta"
            className="inline-flex items-center gap-2 mt-7 rounded-full px-7 py-3.5 font-heading font-semibold uppercase text-sm tracking-wide text-black hover:opacity-85 transition-opacity duration-300"
            style={{ backgroundColor: "#A4C8E1" }}>
            {t({ fr: "Réserver ma place", en: "Book my spot", es: "Reservar mi plaza" })} <ArrowUpRight size={18} />
          </Link>
        </div>
        <div className="lg:col-span-7 grid grid-cols-4 gap-3 md:gap-5">
          {vals.map((v, i) => (
            <div key={i} data-testid={`countdown-${i}`} className="rounded-md border border-white/10 bg-black/30 py-6 md:py-9 text-center">
              <div className="font-display text-4xl md:text-6xl" style={{ color: "#A4C8E1" }}>{String(v).padStart(2, "0")}</div>
              <div className="font-mono text-[8px] md:text-[10px] uppercase tracking-[0.25em] text-white/50 mt-2">{t(LABELS[i])}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
